export default __webpack_public_path__ + "static/media/h-bg.14ce9c89.webp";